import { render, staticRenderFns } from "./BLPayment.vue?vue&type=template&id=9deba2a4&"
import script from "./BLPayment.vue?vue&type=script&lang=js&"
export * from "./BLPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports